import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Map as ImmutableMap } from 'immutable';

import { readRequest } from 'actions/notifications';

import { toI18n } from 'util/i18n';
import { browserHistory } from 'util/router';

import AlertsListItem from '../AlertsListItem';

type ExpiredCertificateProps = {
  item: ImmutableMap<string, any>;
  closeDrawer: () => void;
};

const ExpiredCertificate = ({
  item,
  closeDrawer,
  ...rest
}: ExpiredCertificateProps) => {
  const dispatch = useDispatch();

  const handleDismiss = useCallback(() => {
    dispatch(readRequest(item));
  }, [dispatch, item]);

  const handleView = useCallback(() => {
    closeDrawer();
    browserHistory.push(`/team/${item.get('user_id')}/personal_information`);
  }, [closeDrawer, item]);

  return (
    <AlertsListItem
      desc={item.get('body')}
      onEdit={handleView}
      onDismiss={handleDismiss}
      editButton={toI18n('actions.view')}
      dismissButton={toI18n('actions.dismiss')}
      item={item}
      {...rest}
    />
  );
};

export default memo(ExpiredCertificate);
